import { DrawerProps } from "@fluentui/react-components";
import * as React from "react";
import {
  NavDrawer,
  NavDrawerBody,
  NavItem,
  NavDrawerProps,
} from "@fluentui/react-nav-preview";

import { makeStyles, tokens } from "@fluentui/react-components";
// 1. Import useLocation
import { useNavigate, useLocation } from "react-router-dom";
import { checkUserPermission, convertStringToArray } from "../../utils";
import { UserPermissionsList } from "../../config";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const useStyles = makeStyles({
  root: {
    overflow: "hidden",
    display: "flex",
    height: "calc(100vh - 150px)",
    width: "200px",
  },
});

type DrawerType = Required<DrawerProps>["type"];

const Sidebar = (props: Partial<NavDrawerProps>) => {
  const styles = useStyles();
  const navigate = useNavigate();
  // 2. Get current location
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(true);
  const [type, setType] = React.useState<DrawerType>("inline");
  // 3. Logic to determine which value is active based on the URL
  const selectedValue = React.useMemo(() => {
    if (location.pathname.includes("/utilities/email")) return "email";
    if (location.pathname.includes("/utilities/letter")) return "letter";
    if (location.pathname.includes("/utilities/report")) return "report";
    return "";
  }, [location.pathname]);

  return (
    <div className={styles.root}>
      <NavDrawer
        open={isOpen}
        type={type}
        size="medium"
        // 4. Bind the selectedValue to the current route
        selectedValue={selectedValue}
      >
        <NavDrawerBody>
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "utilities_email"
          ) && (
              <NavItem
                onClick={() => navigate("/utilities/email")}
                value="email"
              >
                Email
              </NavItem>
            )}

          <NavItem
            onClick={() => navigate("/utilities/letter")}
            value="letter"
          >
            Letter
          </NavItem>
        </NavDrawerBody>
      </NavDrawer>
    </div>
  );
};

export default Sidebar;